export default {"src":"/_next/static/media/robinhood-logo.01cc6a46.svg","height":26,"width":136,"blurWidth":0,"blurHeight":0};